module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-record-meters"
  }, [_c('h2', [_vm._v("公寓水电表记录")]), _c('div', {
    staticClass: "ui message"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("上次抄表时间")]), _c('p', [_vm._v(_vm._s(_vm.$formatters.date.to_datetime_cn(_vm.previous.time_created)) + " (" + _vm._s(_vm.$formatters.date.from_now(_vm.previous.time_created)) + ")")])])]), _c('h3', [_vm._v("水表")]), _c('div', {
    staticClass: "ui four columns grid stackable form"
  }, [_vm._l((_vm.$defines.meters.water.orders), function(meter_key) {
    return _c('div', {
      staticClass: "ui field column"
    }, [_c('compare-input', {
      attrs: {
        "previous": _vm.previous.water[meter_key],
        "label": _vm.$defines.meters.water.meters[meter_key].label
      },
      model: {
        value: (_vm.water.values[meter_key]),
        callback: function($$v) {
          _vm.$set(_vm.water.values, meter_key, $$v)
        },
        expression: "water.values[meter_key]"
      }
    })], 1)
  }), _vm._l((_vm.$defines.meters.water.computed), function(meter, meter_key) {
    return _c('div', {
      staticClass: "ui field column"
    }, [_c('compare-input', {
      attrs: {
        "previous": _vm.previous.water[meter_key],
        "label": meter.label,
        "disabled": true
      },
      model: {
        value: (_vm.water.computed[meter_key]),
        callback: function($$v) {
          _vm.$set(_vm.water.computed, meter_key, $$v)
        },
        expression: "water.computed[meter_key]"
      }
    })], 1)
  })], 2), _c('h3', [_vm._v("电表")]), _c('div', {
    staticClass: "ui four columns grid stackable form"
  }, [_vm._l((_vm.$defines.meters.electricity.orders), function(meter_key) {
    return _c('div', {
      staticClass: "ui field column"
    }, [_c('compare-input', {
      attrs: {
        "previous": _vm.previous.electricity[meter_key],
        "label": _vm.$defines.meters.electricity.meters[meter_key].label
      },
      model: {
        value: (_vm.electricity.values[meter_key]),
        callback: function($$v) {
          _vm.$set(_vm.electricity.values, meter_key, $$v)
        },
        expression: "electricity.values[meter_key]"
      }
    })], 1)
  }), _vm._l((_vm.$defines.meters.electricity.computed), function(meter, meter_key) {
    return _c('div', {
      staticClass: "ui field column"
    }, [_c('compare-input', {
      attrs: {
        "previous": _vm.previous.electricity[meter_key],
        "label": meter.label,
        "disabled": true
      },
      model: {
        value: (_vm.electricity.computed[meter_key]),
        callback: function($$v) {
          _vm.$set(_vm.electricity.computed, meter_key, $$v)
        },
        expression: "electricity.computed[meter_key]"
      }
    })], 1)
  })], 2), _c('div', {
    staticClass: "ui field actions"
  }, [_c('div', {
    staticClass: "ui button themed",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存")]), _c('div', {
    staticClass: "ui button",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32bc7360","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/forms/FormRecordMeters.vue
// module id = 404
// module chunks = 0